import React from 'react';

// bg-about-pattern-first w-[434px] h-[533px] rounded-md

const About = () => {
	return (
		<div
			id='about'
			className='py-12 px-6 flex flex-col justify-center items-center bg-[#dee6e7] lg:flex-row lg:space-x-24'
		>
			<div
				className='bg-about-pattern-first bg-cover w-[200px] h-[200px] my-12 rounded-md
			 sm:w-[300px] sm:h-[300px] md:w-[350px] md:h-[350px] lg:h-[450px] xl:w-[500px] xl:h-[580px] shadow-xl'
			></div>
			<div>
				<h2 className='text-3xl sm:text-4xl md:text-5xl'>About Me</h2>
				<div className='mt-4 text-start text-lg mb-8 sm:w-[30rem] sm:text-xl'>
					<p>
						More than one year, I developed an interest in web development and I
						started studying frontend web development, my goal is to become an
						excellent web developer. I have mastered at{' '}
						<strong>JavaScript, HTML, CSS,</strong> and besides those basics, I
						am well acquainted with{' '}
						<strong>
							{' '}
							React.js, Vue.js , SCSS/SASS, Tailwind CSS, Bootstrap, Sanity.io,
							GraphQL, Hygraph, Figma, NPM, UX/UI Design and Responsive Web
							Design.
						</strong>{' '}
					</p>
					<br />
					<p>
						{' '}
						The fields that I want to work and develop myself are UI/UX design
						development. Regardless of domestic or abroad, I can work as a
						frontend developer in the field.
					</p>
					<br />
					<p>
						I have been working as an Energy Systems Engineer in a factory for
						five years. The education I received in university comprises
						branches of mechanical-heat energy, power plants, energy efficiency,
						ventilation, air conditioning, and cooling in the sector. During my
						university life, I had the opportunity to work and internship in
						different places on engineering.
					</p>
					<br />
					<p>
						R&D, P&D, and halftime manufacturing engineering, the way supporting
						production, had been the departments I worked. Sectors I have been
						worked for so far comprise Air Conditioning, Ventilation, and
						Industrial Cooling Areas. In this period, I have a part in creating
						a new product's mechanical design of 2D/3D drawings, developing
						present mechanical designs, and designing pipes predominantly.
					</p>
					<br />
					In my education life, I had been in Italy for six months within the
					scope of the Erasmus student exchange program. In my spare time I go
					to gym and sometimes play tennis.
				</div>
			</div>
		</div>
	);
};

export default About;
